import { render, staticRenderFns } from "./UserInfoMenu.vue?vue&type=template&id=59c99a9a"
import script from "./UserInfoMenu.vue?vue&type=script&lang=js"
export * from "./UserInfoMenu.vue?vue&type=script&lang=js"
import style0 from "./UserInfoMenu.vue?vue&type=style&index=0&id=59c99a9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports